<template>
  <NavBar pageName="Bursa digitala"></NavBar>

  <v-container style="margin-top: 185px;">
    <h2 class="text-h4 mb-4">Bursa digitala</h2>
    <v-card class="text-center pa-8 mx-auto" max-width="600">
      <v-icon size="80" color="warning" class="mb-4">mdi-hammer-wrench</v-icon>
      <v-card-title class="text-h4 mb-2">Under Construction</v-card-title>
      <v-card-text>
        <p class="text-body-1 mb-4">
          This feature is currently under development.
        </p>
        <p v-if="msisdn" class="text-body-2 text-grey">
          MSISDN: <strong>{{ msisdn }}</strong>
        </p>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" variant="outlined" @click="$router.back()">
          <v-icon start>mdi-arrow-left</v-icon>
          Go Back
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue';
import NavBar from "@/components/NavBar.vue";

export default defineComponent({
  name: 'UnderConstruction',
  components: { NavBar },
  computed: {
    msisdn() {
      return this.$route.query.msisdn || null
    }
  }
});
</script>
